import { createSelector } from "reselect"
import { get, first, last, chain, size, map, some } from "lodash"
import { computeFactorCategories } from "helpers/factors"
import { getSelectedViews, getSelectedViewsFactors } from "modules/factor-trends/selectors/factors"
import { getFactorCalculationResultsByDate } from "modules/factor-trends/helpers"

export const getFactorsRisk = state => get(state, "global.data.factorTrendsRisk.data.model.factors")

const getFactorsRiskByDate = createSelector(
  [getFactorsRisk],
  (factors) => getFactorCalculationResultsByDate(factors, "risk"),
)

export const getRiskHistory = createSelector(
  [getFactorsRiskByDate, getSelectedViews, getSelectedViewsFactors],
  (riskHistory, selectedViews, selectedViewsFactors) => map(riskHistory, (daily, date) => {
    let factors = daily

    if (size(selectedViews)) {
      factors = chain(daily)
        .filter(factor => some(selectedViewsFactors, item => item.id === factor.id))
        .map(factor => ({ ...factor, customView: true }))
        .concat(factors)
        .value()
    }

    factors = chain(factors)
      .keyBy(factor => factor.id)
      .mapValues(factor => factor.value)
      .value()

    return {
      date,
      factors,
      categories: computeFactorCategories(factors, selectedViews),
    }
  }),
)

export const getCurrentRisk = createSelector(
  [getRiskHistory],
  (risk) => last(risk),
)

export const getFirstRiskDate = createSelector(
  [getRiskHistory],
  (riskHistory) => get(first(riskHistory), "date", null),
)
